import React from 'react';
import { parseISO } from 'date-fns';

import { Ratings } from '@loyalup/ui';

const fields = [];

const registerField = ({ label, render, ...opts }) => {
  const renderFn = typeof render === 'string' ? obj => obj[render] : render;
  const labelFn = typeof label === 'string' ? t => t(label) : label;
  fields.push({ label: labelFn, render: renderFn, ...opts });
};

const isEmpty = value => value === undefined || value === null || value === '';
const withEmpty = (value, fn) => (isEmpty(value) ? undefined : fn(value));

const findFeedbacksField = name => fields.find(field => field.name === name);

const getFeedbacksFields = opts => {
  const { filter } = opts || {};

  return filter ? fields.filter(field => filter.includes(field.name)) : fields;
};

registerField({
  label: 'Дата и время',
  name: 'datetime',
  type: 'date',
  render: ({ datetime }, t) => t('{{datetime, datetime_short}}', { datetime: parseISO(datetime) }),
});

registerField({
  label: 'Оценка',
  name: 'rating',
  type: 'number',
  render: ({ rating, id }) => {
    return <Ratings key={id} value={rating} />;
  },
});

registerField({
  label: 'Отзыв',
  name: 'text',
  type: 'text',
  render: ({ text }) => text,
});

registerField({
  label: 'Клиент',
  name: 'clients.id',
  type: 'present',
  render: ({ client }, t) => {
    if (client?.id) return t('Указано');
    return t('Не указано');
  },
  system: true,
});

registerField({
  label: 'Имя',
  name: 'clients.firstName',
  type: 'text',
  render: ({ client }) => client?.firstName,
  system: true,
});

registerField({
  label: 'Фамилия',
  name: 'clients.lastName',
  type: 'text',
  render: ({ client }) => client?.lastName,
  system: true,
});

registerField({
  label: 'Дата Рождения',
  name: 'clients.bday',
  type: 'date',
  render: ({ client }, t) => withEmpty(client?.bday, () => t('{{date, date}}', { date: new Date(client?.bday) })),
  system: true,
});

registerField({
  label: 'Номер Карты',
  name: 'clients.cardNumber',
  type: 'text',
  render: ({ client }) => client?.cardNumber,
  system: true,
});

registerField({
  name: 'clients.email',
  type: 'email',
  render: ({ client }) => client?.email,
  label: 'Е-мейл',
  parse: v => withEmpty(v, v => v),
  system: true,
});

registerField({
  name: 'clients.insertedAt',
  type: 'date',
  render: ({ client }, t) =>
    withEmpty(client?.insertedAt, () => t('{{date, date}}', { date: new Date(client?.insertedAt) })),
  label: 'Дата Добавления',
  parse: v => withEmpty(v, v => v),
  system: true,
});

registerField({
  label: 'Телефон',
  name: 'clients.phone',
  type: 'text',
  render: ({ client }) => client?.phone,
  system: true,
});

registerField({
  label: 'Пол',
  name: 'clients.gender',
  type: 'text',
  render: ({ client }, t) => {
    if (client?.gender === 'MALE') return t('муж');
    if (client?.gender === 'FEMALE') return t('жен');
  },
  system: true,
});

registerField({
  label: 'Доп. Поле 1 Клиента',
  name: 'clients.extra1',
  type: 'text',
  render: ({ client }) => client?.extra1,
  system: true,
});

export { getFeedbacksFields, findFeedbacksField };
